import { readFileSync } from "node:fs";
import { join } from "node:path";
import { ImageResponse } from "next/og";

export const alt = "Alqove — curated resale from verified stores";
export const size = { width: 1200, height: 630 };
export const contentType = "image/png";

/**
 * Satori cannot fetch from our own origin while it is generating this response,
 * so the wordmark is read off disk and inlined as a data URI at module load.
 */
const WORDMARK = `data:image/svg+xml;base64,${readFileSync(
  join(process.cwd(), "public/brand/logo_inverse.svg"),
).toString("base64")}`;

/** `brand.forest` / `brand.sage` in @alqove/design-tokens — inlined because
 *  satori resolves no CSS custom properties. */
const FOREST = "#1f3a2e";
const SAGE = "#d3e0c6";

/** The default social card for every route that does not supply its own. */
export default function OpengraphImage() {
  return new ImageResponse(
    (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 40,
          backgroundColor: FOREST,
        }}
      >
        <img src={WORDMARK} width={560} height={135} alt="" />
        <div style={{ fontSize: 34, color: SAGE }}>
          Curated resale from verified stores
        </div>
      </div>
    ),
    size,
  );
}
